module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9610.871a5803.jpg";